module.exports = __webpack_public_path__ + "img/m-banner-cjizfoaj-en-US.424e3b08.png";